import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { MapContainer, TileLayer } from 'react-leaflet'
import { FeatureGroup } from 'react-leaflet'
import { EditControl } from 'react-leaflet-draw'
import { area } from '@turf/turf'
import 'leaflet/dist/leaflet.css'
import 'leaflet-draw/dist/leaflet.draw.css'
import 'src/reusable/leaflet-draw-locale-es'

const MapaDibujable = ({ onAreaSelect }) => {
  const featureGroupRef = useRef(null)
  const zoom = window.innerWidth > 768 ? 8 : 7

  const _onCreated = (e) => {
    let poligonos = []
    featureGroupRef.current?.getLayers().map((layer) => {
      const id = layer._leaflet_id
      const geoJsonData = layer.toGeoJSON()
      const poligonoNuevo = { id, coord: geoJsonData, area: calcularArea(geoJsonData) }
      poligonos = [...poligonos, poligonoNuevo]
    })
    onAreaSelect(poligonos)
  }

  const _onEdited = (e) => {
    let poligonos = []
    featureGroupRef.current?.getLayers().map((layer) => {
      const id = layer._leaflet_id
      const geoJsonData = layer.toGeoJSON()
      const poligonoNuevo = { id, coord: geoJsonData, area: calcularArea(geoJsonData) }
      poligonos = [...poligonos, poligonoNuevo]
    })
    onAreaSelect(poligonos)
  }

  const _onDeleted = (e) => {
    let poligonos = []
    featureGroupRef.current?.getLayers().map((layer) => {
      const id = layer._leaflet_id
      const geoJsonData = layer.toGeoJSON()
      const poligonoNuevo = { id, coord: geoJsonData, area: calcularArea(geoJsonData) }
      poligonos = [...poligonos, poligonoNuevo]
    })
    onAreaSelect(poligonos)
  }

  const calcularArea = (poligono) => {
    return area(poligono) / 10000
  }

  return (
    <MapContainer center={[-32.2, -59.4]} zoom={zoom} className="mapa-dibujable">
      <TileLayer
        url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
        attribution="ESRI Imagery/Satellite"
        ext="jpg"
      />
      <TileLayer url="https://mt1.google.com/vt/lyrs=h&x={x}&y={y}&z={z}" attribution="google" />
      <FeatureGroup ref={featureGroupRef}>
        <EditControl
          position="topright"
          onCreated={_onCreated}
          onEdited={_onEdited}
          onDeleted={_onDeleted}
          draw={{
            rectangle: false,
            circle: false,
            polyline: false,
            marker: false,
            circlemarker: false,
          }}
        />
      </FeatureGroup>
    </MapContainer>
  )
}

MapaDibujable.propTypes = {
  onAreaSelect: PropTypes.func,
}

export default MapaDibujable
